import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdClose,
  MdDelete,
  MdEdit,
  MdVisibility,
  MdWarning,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import api from "../../../services/api";
import {
  Card,
  HeaderTitle,
  ViewInput,
  Table,
  Scroll,
  Message,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import { Button, Modal, Input, Pagination, Select, Spin, Tooltip } from "antd";
import { Container } from "./styles";
import { format } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

import { ExclamationCircleFilled } from "@ant-design/icons";
const { TextArea } = Input;
const { confirm } = Modal;

dayjs.extend(weekday);
dayjs.extend(localeData);

const Comunicados = () => {
  const navigate = useNavigate();

  const [statements, setStatements] = useState([]);
  const [statementsTotal, setStatementsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState("");
  const [users, setUsers] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    loadStatements(page);
  }, [page]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadStatements(page) {
    await api
      .get(`/statements?page=${page}`)
      .then((response) => {
        setStatements(response.data.statements);
        setStatementsTotal(response.data.statementsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createStatement() {
    setIsLoadingModal(true);
    if (!title || !description) {
      toast.warn("Preencha o titulo e descrição para salvar comunicado");
    } else {
      if (id) {
        await api
          .put(`/statement/${id}`, {
            title: title,
            description: description,
          })
          .then((response) => {
            toast.success("Comunicado editado com sucesso");
            loadStatements(page);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/statement`, {
            title: title,
            description: description,
          })
          .then((response) => {
            toast.success("Comunicado criado com sucesso");
            loadStatements(page);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteStatement(statement) {
    await api
      .delete(`/statement/${statement.id}`)
      .then(() => {
        toast.success("Comunicado deletado com sucesso");
        loadStatements(page);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }
  return (
    <Container>
      <HeaderTitle>
        <h1>Comunicados</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            setId("");
            setTitle("");
            setDescription("");
            setIsOpen(true);
          }}
        >
          <MdAdd size="20" color="#fff" />
          <span>Criar Comunicado</span>
        </Button>
      </HeaderTitle>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={statementsTotal} separator="." />
      </Card>
      <div className="filters-row">
        <ViewInput style={{ width: "100%", maxWidth: 300 }}>
          <p>Filtrar Presença por Franqueado</p>
          <Select
            placeholder="selecionar franqueado"
            value={user}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setUser(value);
              setPage(0);
            }}
          >
            <Select.Option value={""}>Todos Franqueados</Select.Option>
            {users.map((item) => {
              return (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              );
            })}
          </Select>
        </ViewInput>
      </div>

      {!isLoading && (
        <>
          {statements?.length ? (
            <div className="statements-list">
              {statements.map((statement) => (
                <div className="statement-card" key={statement.id}>
                  <div className="main-info">
                    <Tooltip title={statement.title}>
                      <strong>{statement.title}</strong>
                    </Tooltip>
                    <span>Comunicado</span>
                  </div>

                  <div className="info-item">
                    <label>Descrição</label>
                    <Tooltip title={statement.description}>
                      <span
                        style={{
                          maxWidth: 250,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {statement.description}
                      </span>
                    </Tooltip>
                  </div>

                  <div className="info-item">
                    <label>Presença / Confirmação</label>
                    <span style={{ fontWeight: "bold", color: "#008037" }}>
                      {statement.statement_confirms.length} / {users.length}{" "}
                      confirmados
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Criado em</label>
                    <span>
                      {format(
                        new Date(statement.create_at),
                        "dd/MM/yyyy HH:mm",
                      )}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Ver Confirmações">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          navigate(`/admin/comunicado/${statement.id}`);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Editar">
                      <Button
                        shape="circle"
                        icon={<MdEdit size={18} />}
                        onClick={() => {
                          setId(statement.id);
                          setTitle(statement.title);
                          setDescription(statement.description);
                          setIsOpen(true);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <Button
                        shape="circle"
                        danger
                        icon={<MdDelete size={18} />}
                        onClick={() => {
                          confirm({
                            okText: "Confirmar",
                            title: "Deseja excluir o Comunicado?",
                            icon: <ExclamationCircleFilled />,
                            content: `Após essa ação, o Comunicado ${statement.title} será excluido.`,
                            onOk() {
                              deleteStatement(statement);
                            },
                            onCancel() {},
                            cancelText: "Cancelar",
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))}

              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={statementsTotal}
                pageSize={30}
                showTotal={(total) => `${total} comunicados`}
              />
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <MdWarning size={50} color="#ccc" style={{ marginBottom: 15 }} />
              <Message>Nenhum comunicado encontrado.</Message>
            </div>
          )}
        </>
      )}

      {isLoading && <Spin size="large" style={{ marginTop: 50 }} />}

      <Modal
        title={id ? "Editando comunicado" : "Cadastrando um novo comunicado"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          createStatement();
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <ViewInput>
          <p>Titulo*</p>
          <Input
            placeholder="titulo"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Descrição</p>
          <TextArea
            style={{ minHeight: 60 }}
            placeholder="descrição"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>
    </Container>
  );
};

export default Comunicados;
